import React, { useState, useEffect, useMemo } from 'react';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../Core/Grid/inputFormatter';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import ReactDOM from 'react-dom';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import DialogComp from '../../../Core/Modal/dialogModal';
import { getAllDropdowns } from '../../../Core/Service/vmrs-service';
import ScheduleEventDialog from './scheduleEventsDialog';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Schedule Events', active: true }
];
const basecolumns = [
    { field: 'action', title: 'Action', width: '5%' },
    { field: 'scheduleEventName', title: 'Name' },
    { field: 'scheduleEventInternalTypeTitle', title: 'Event Type' },
    { field: 'scheduleVMRSCategory', title: 'VMRS Category' },
    { field: 'scheduleVMRSSubCategory', title: 'VMRS Sub Category' }
];

const ScheduleEvent = () => {
    const [state, setState] = useState({
        open: false,
        showLoader: true,
        selectedRowData: {},
        isAdd: true
    });

    const pullApiData = async () => {
        // let res = await getAllScheduleEvents();
        let dropDownResponse = await getAllDropdowns();
        setState((st) => ({
            ...st,
            // rows: [...res.data],
            dropDown: dropDownResponse.data,
            isReload: new Date()
            // showLoader: false
        }));
    };

    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center" justifyContent="center">
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    // onClick={() => addBtnClicked(record)}
                    onClick={() => {
                        addBtnClicked(record);
                    }}
                >
                    <EditIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const addButton = (gridRef, valueList) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ paddingRight: '7px' }}>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px',
                        marginLeft: '20px'
                    }}
                    onClick={() => addBtnClicked()}
                >
                    <AddIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.field === 'action');
        if (actionCol) {
            actionCol.renderer = editButton;
        }
        return tempCols;
    }, []);

    const addBtnClicked = (record) => {
        setState((st) => ({
            ...st,
            open: true,
            isAdd: true,
            selectedRowData: record
        }));
    };
    const handleClose = (res) => {
        setState((st) => ({
            ...st,
            open: false,
            selectedRowData: {}
        }));
        res && pullApiData();
    };

    const urlState = 'ScheduleEvents';
    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />
            <ReportGijgoGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                columns={columns}
                getUrl={'ScheduleEvents'}
                AddBtn={addButton}
                isReload={state.isReload}
            />

            {state.open ? (
                <DialogComp
                    open={state.open}
                    onClose={() => {
                        handleClose(false);
                    }}
                    title={!state.selectedRowData?.scheduleEventID ? 'Add Schedule Event' : 'Edit Schedule Event'}
                    maxWidth="lg"
                    overflow="auto"
                >
                    <ScheduleEventDialog
                        data={state}
                        selectedRowData={state.selectedRowData}
                        onClose={() => {
                            handleClose(true);
                        }}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default ScheduleEvent;
